// Paladin: escolhe a flecha ou o bolt, de graça (decisão do Arthur, 15/10). Mostra todas as munições do jogo com dano,
// elemento, como funcionam (burst/diamond em área, poison/viper envenenam) e o level exigido.
import { catalogNow } from '../items';
import { ItemImg } from './ItemSlot';
import { AMMO_SCRIPTS } from '../../../../shared/src/game/ammo';
import type { ItemInstance } from '../../../../shared/src/game/items';

const ELEM: Record<string, string> = { fire: 'fogo', ice: 'gelo', energy: 'energia', earth: 'terra', holy: 'sagrado', death: 'morte', physical: 'físico' };

function how(id: number): string {
  const sc = AMMO_SCRIPTS[id];
  if (!sc) return '';
  const parts: string[] = [];
  if (sc.area) parts.push(`ataque em área ${sc.area.length}x${sc.area[0]!.length}${sc.area.length === 5 ? ' (círculo)' : ''} em volta do alvo`);
  if (sc.poison) parts.push(`envenena: ${sc.poison.reduce((t, [n, , d]) => t + n * d, 0)} de dano de terra aos poucos`);
  if (sc.formula === 'skill') parts.push('dano de 0 até o máximo');
  if (sc.noBlackSkull) parts.push('não funciona com black skull');
  return parts.join(' · ');
}

export function AmmoPicker(props: { level: number; items: ItemInstance[]; onPick: (typeId: number) => void }) {
  const cat = catalogNow();
  const weapon = props.items.find((i) => i.place === 'equip' && i.slot === 'weapon');
  const wt = weapon ? cat?.get(weapon.typeId) : undefined;
  const cur = props.items.find((i) => i.place === 'equip' && i.slot === 'ammo')?.typeId;
  const list = [...(cat?.values() ?? [])].filter((t) => t.slot === 'ammo' && (t.ammoType === 'arrow' || t.ammoType === 'bolt') && (t.attack ?? 0) > 0)
    // o catálogo tem cópias com o mesmo nome (ex.: dois diamond arrow): mostra uma só, a equipada se for o caso
    .filter((t, _i, all) => { const twin = all.filter((o) => o.name.toLowerCase() === t.name.toLowerCase() && o.ammoType === t.ammoType); return (twin.find((o) => o.id === cur) ?? twin[0]) === t; })
    .sort((a, b) => (a.ammoType === b.ammoType ? 0 : a.ammoType === 'arrow' ? -1 : 1) || (a.level ?? 0) - (b.level ?? 0) || (a.attack ?? 0) - (b.attack ?? 0));
  return (
    <div class="ammo-pick">
      <p class="small">Escolha a munição de graça (o refine dela, +1 a +30, fica no espaço: trocar de flecha ou bolt mantém o +N; refine na janela de Refine). <b>Flechas</b> só funcionam com <b>arco (bow)</b> e <b>bolts</b> só com <b>besta (crossbow)</b>.
        {wt?.ammoType ? <> Sua arma ({wt.name}) usa <b>{wt.ammoType === 'arrow' ? 'flechas' : 'bolts'}</b>.</> : ' Equipe um arco ou uma besta.'}</p>
      {(['arrow', 'bolt'] as const).map((kind) => (
        <div key={kind}>
          <div class="ammo-cap">{kind === 'arrow' ? 'Flechas (arco)' : 'Bolts (besta)'}</div>
          <ul class="ammo-list">
            {list.filter((t) => t.ammoType === kind).map((t) => {
              const locked = !!t.level && props.level < t.level;
              const elem = String(t.elementAttack ?? '').match(/(\d+)\s*(\w+)/);
              const h = how(t.id);
              return (
                <li key={t.id} class={(locked ? 'locked' : '') + (cur === t.id ? ' on' : '') + (wt?.ammoType && wt.ammoType !== kind ? ' other' : '')}>
                  <span class="item-slot"><ItemImg typeId={t.id} count={1} /></span>
                  <span class="ammo-info">
                    <b>{t.name}</b>
                    <small>Ataque {t.attack}{elem ? ` + ${elem[1]} de ${ELEM[elem[2]!.toLowerCase()] ?? elem[2]}` : ''}{t.level ? ` · level ${t.level}` : ''}</small>
                    {h && <small class="ammo-how">{h}</small>}
                  </span>
                  <button class="tb-button green" disabled={locked || cur === t.id} onClick={() => props.onPick(t.id)}>{cur === t.id ? 'Em uso' : locked ? `Level ${t.level}` : 'Usar'}</button>
                </li>
              );
            })}
          </ul>
        </div>
      ))}
    </div>
  );
}
